import { customTheme } from '@styles/survey-ui/survey-custom-theme';
import React, { useMemo } from 'react';
import { Model } from "survey-core";
import { Survey } from "survey-react-ui";

export function SurveyPreview({ json }) {
    if (!json) return <em>Sem estrutura</em>;

    const model = useMemo(() => {
        const survey = new Model(json);

        survey.applyTheme({ themeName: "customTheme", cssVariables: customTheme.cssVariables });
        survey.mode = "display";
        survey.showCompletedPage = false;
        
        return survey;
    }, [json]);

    return (
        <div style={{ maxHeight: 500, overflow: 'auto' }}>
            <Survey model={model} />
        </div>
    );
}
